import type { ReactNode } from 'react';
import { AlertIcon } from '@/components/icons';
import { cn } from '@/lib/cn';
import { Button } from './Button';

type ErrorStateProps = {
  title: string;
  message?: ReactNode;
  /** Shows a danger "Try again" button. */
  onRetry?: () => void;
  retryLabel?: string;
  action?: ReactNode;
  className?: string;
};

/** Danger border + soft background, alert icon, `role="alert"` (DESIGN.md §4 ErrorState / Alert). */
export function ErrorState({
  title,
  message,
  onRetry,
  retryLabel = 'Try again',
  action,
  className,
}: ErrorStateProps) {
  return (
    <div
      role="alert"
      className={cn('flex gap-3 rounded-lg border border-danger bg-danger-soft p-4', className)}
    >
      <AlertIcon size={20} className="mt-0.5 shrink-0 text-danger" />
      <div className="flex min-w-0 flex-col items-start gap-2">
        <p className="m-0 text-sm font-semibold text-danger-ink">{title}</p>
        {message && <div className="m-0 text-sm text-danger-ink">{message}</div>}
        {(onRetry || action) && (
          <div className="flex flex-wrap gap-2 pt-1">
            {onRetry && (
              <Button variant="danger" size="sm" onClick={onRetry}>
                {retryLabel}
              </Button>
            )}
            {action}
          </div>
        )}
      </div>
    </div>
  );
}
